import { render } from "./AssertionsDynamicsCard.vue?vue&type=template&id=20b7ab56&scoped=true"
import script from "./AssertionsDynamicsCard.vue?vue&type=script&lang=js"
export * from "./AssertionsDynamicsCard.vue?vue&type=script&lang=js"

import "./AssertionsDynamicsCard.vue?vue&type=style&index=0&id=20b7ab56&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b7ab56"]])

export default __exports__